/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Barcode(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M224,40H184a8,8,0,0,0,0,16h32V88a8,8,0,0,0,16,0V48A8.00039,8.00039,0,0,0,224,40Z" />
        <Path d="M72,200H40V168a8,8,0,0,0-16,0v40a8.00039,8.00039,0,0,0,8,8H72a8,8,0,0,0,0-16Z" />
        <Path d="M224,160a8.00039,8.00039,0,0,0-8,8v32H184a8,8,0,0,0,0,16h40a8.00039,8.00039,0,0,0,8-8V168A8.00039,8.00039,0,0,0,224,160Z" />
        <Path d="M32,96a8.00039,8.00039,0,0,0,8-8V56H72a8,8,0,0,0,0-16H32a8.00039,8.00039,0,0,0-8,8V88A8.00039,8.00039,0,0,0,32,96Z" />
        <Path d="M80,80a8.00039,8.00039,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8.00039,8.00039,0,0,0,80,80Z" />
        <Path d="M184,168V88a8,8,0,0,0-16,0v80a8,8,0,0,0,16,0Z" />
        <Path d="M144,80a8.00039,8.00039,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8.00039,8.00039,0,0,0,144,80Z" />
        <Path d="M112,80a8.00039,8.00039,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8.00039,8.00039,0,0,0,112,80Z" />
      </G>
    </Svg>
  );
}

export default Barcode;
